import Coupon from "../../../Components/Cards/Coupon/Coupon";
import FilterColorful from "../../../Components/Buttons/FilterColorful";
import { useState } from "react";
import { isoToJalali } from "../../../helper/isoToJalali";
import { useNavigate } from "react-router-dom";
import SVG from "../../../Components/SVG";
import { API_BASE_URL } from "../../../config/api";
import useInfinitePaginated, { mergeNestedBuckets } from "../../../hooks/useInfinitePaginated";
import InfiniteScrollFooter from "../../../Components/InfiniteScrollFooter";

const EMPTY_COUPONS = { belong_to_you: { active: [], used: [], expired: [] }, for_all: { active: [], used: [], expired: [] } };
const mergeCoupons = mergeNestedBuckets(["belong_to_you", "for_all"], ["active", "used", "expired"], (coupon) => coupon?.uuid);

export default function CardsGeneral() {
  const navigate = useNavigate();
  const [, setAccLoading] = useState(true);
  const { data: coupon, initialLoading: accLoading, loadingMore, error, hasNext, sentinelRef, retry } = useInfinitePaginated({
    endpoint: `${API_BASE_URL}challenges/trader/coupons/`, navigate, initialData: EMPTY_COUPONS,
    select: (response) => response.results || EMPTY_COUPONS, merge: mergeCoupons,
  });
  const [activeFilter, setActiveFilter] = useState([true, true]);
  return (
    <div className="w-full p-5 flex flex-col gap-5 rounded-2xl bg-zi-bg2-light dark:bg-zi-bg2-dark">
      <div className="w-full flex gap-2.5 items-center justify-start pt-px pb-2.5 border-b border-b-zi-border-light dark:border-b-zi-border-dark overflow-y-visible overflow-x-auto">
        <span className="text-xs font-light text-zi-text-light dark:text-zi-text-dark">
          فیلتر:
        </span>
        <FilterColorful
          SVGName="tick"
          text="فعال"
          className="w-[104px]"
          color={activeFilter[0] ? "green" : "gray"}
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          filterIndex={0}
        />
        <FilterColorful
          SVGName="star"
          text="استفاده شده"
          className="w-[104px]"
          color={activeFilter[1] ? "blue" : "gray"}
          activeFilter={activeFilter}
          setActiveFilter={setActiveFilter}
          filterIndex={1}
        />
      </div>

      <div className="w-full grid grid-cols-1 lg:grid-cols-2 justify-items-center gap-x-10 gap-y-20 relative min-h-[191.44px]">
        {coupon &&
          activeFilter[0] &&
          coupon.for_all.active.map((item) => (
            <Coupon
              accLoading={accLoading}
              setAccLoading={setAccLoading}
              color="green"
              code={item.name}
              title={`کد تخفیف ${Number(item.discount_percent).toFixed(
                0,
              )} درصدی`}
              challenge={
                item.is_for_all_challenges
                  ? `برای همه چالش ها`
                  : item.challenge_category
                    ? `مخصوص دسته ${item.challenge_category}`
                    : `مخصوص چالش ${item.challenge_name}`
              }
              expiration={`معتبر تا ${isoToJalali(item.expired_at)}`}
            />
          ))}
        {coupon &&
          activeFilter[1] &&
          coupon.for_all.used.map((item) => (
            <Coupon
              color="blue"
              accLoading={accLoading}
              setAccLoading={setAccLoading}
              code={item.name}
              title={`کد تخفیف ${Number(item.discount_percent).toFixed(
                0,
              )} درصدی`}
              challenge={
                item.is_for_all_challenges
                  ? `برای همه چالش ها`
                  : item.challenge_category
                    ? `مخصوص دسته ${item.challenge_category}`
                    : `مخصوص چالش ${item.challenge_name}`
              }
              expiration={`معتبر تا ${isoToJalali(item.expired_at)}`}
            />
          ))}
        {accLoading && (
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 justify-items-center gap-x-10 gap-y-20 absolute top-[0px]">
            <div className="w-full max-w-96">
              <div className="w-full aspect-[343/171] rounded-2xl skeleton"></div>
            </div>
            <div className="w-full max-w-96">
              <div className="w-full aspect-[343/171] rounded-2xl skeleton"></div>
            </div>
          </div>
        )}
        {!accLoading && coupon &&
          coupon.for_all.used.length === 0 &&
          coupon.for_all.active.length === 0 && (
            <div className="w-full flex justify-center items-center flex-col gap-5 absolute top-0 left-0">
              <p className="text-zi-text-light dark:text-zi-text-dark">
                موردی برای نمایش وجود ندارد
              </p>
              <SVG name="noData" classname="w-24 fill-cyan-500" />
            </div>
          )}
        {!accLoading && <InfiniteScrollFooter sentinelRef={sentinelRef} loading={loadingMore} error={error} onRetry={retry} hasNext={hasNext} />}
      </div>
    </div>
  );
}
